class OiSearch {
    private oiSearchElement: HTMLElement;
    private formElement: HTMLFormElement | null;

    constructor(overviewElement: HTMLElement) {
        this.oiSearchElement = overviewElement;
        this.formElement = this.oiSearchElement.querySelector('form');

        if (this.formElement) {
            const checkboxes = this.formElement.querySelectorAll<HTMLInputElement>('input[type="checkbox"]');

            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', (event) => {
                    // Get all currently checked checkboxes
                    const checkedBoxes = Array.from(checkboxes).filter(cb => cb.checked);

                    // If the user is trying to uncheck the last one, prevent it
                    if (!checkbox.checked && checkedBoxes.length === 0) {
                        event.preventDefault();
                        checkbox.checked = true; // Re-check the box
                        return;
                    }

                    // Otherwise, submit the form
                    this.formElement!.submit();
                });
            });
        }
    }
}

export default OiSearch;

